import React, { useState } from "react";

import {
    Box,
    Button,
    Modal,
    Stack,
    TextField,
    Typography,
} from "@mui/material";

import api from "../api/axios";

export default function CrearSalaModal({ open, onClose, onCreated }) {
    const [nombre, setNombre] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState(null);

    async function handleCrear() {
        if (!nombre.trim()) return;

        setCargando(true);
        setError(null);

        try {
            await api.post("/salas/", {
                nombre: nombre.trim(),
                descripcion: descripcion.trim() || null,
            });

            setNombre("");
            setDescripcion("");
            onCreated?.();
            onClose();
        } catch (e) {
            setError("No se pudo crear la sala.");
        } finally {
            setCargando(false);
        }
    }

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>
                    Crear sala
                </Typography>

                <Typography variant="body2" sx={{ opacity: 0.75, mb: 2 }}>
                    Crea un espacio compartido para organizar listas.
                </Typography>

                <Stack spacing={2}>
                    <TextField
                        label="Nombre de la sala"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        autoFocus
                        fullWidth
                    />

                    <TextField
                        label="Descripción (opcional)"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                        fullWidth
                    />

                    {error && (
                        <Typography color="error" variant="body2">
                            {error}
                        </Typography>
                    )}

                    <Stack direction="row" justifyContent="flex-end" spacing={1}>
                        <Button onClick={onClose} disabled={cargando}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleCrear}
                            disabled={cargando || !nombre.trim()}
                        >
                            Crear sala
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
}
